import React from 'react'
import { FaPlusCircle } from 'react-icons/fa'
import { classNames } from '../_utils'

const Panel = ( { label, onHandleAdd, handlePress, children, margin = false } ) => {
    return (
        <div className={ classNames( margin ? "border shadow-xl my-3 lg:h-24 md:h-24 h-auto" : "border shadow-xl my-3 h-auto" ) }>
            <div className="w-full bg-gray-600 px-2 flex flex-row items-center justify-between">
                <span className="text-sm text-white p-1">
                    {label}
                </span>
                {onHandleAdd && (
                    <button type="button" className="px-2" onClick={handlePress}>
                        <FaPlusCircle color="#FFF" />
                    </button>
                ) }
            </div>
            <div className="p-2">
                {children}
            </div>
        </div>

    )
}
export default Panel
